import { addDays, format } from "date-fns";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";
import { useEffect, useState } from "react";
import { FaHistory, FaPlus } from "react-icons/fa";
import { FaRegClock } from "react-icons/fa6";
import { toast } from "react-toastify";
import AppCard from "../../../components/appCard";
import { NegotiationDetail } from "../../../components/dashboard/inadimplencias/listagem/detalhes";
import ContraPropostaDialog from "../../../components/dashboard/propostas/contraPropostaDialog";
import ContraPropostaRetornoDialog from "../../../components/dashboard/propostas/contraPropostaRetornoDialog";
import EndingDialog from "../../../components/dashboard/propostas/endingDialog";
import { HistoricoPropostaDialog } from "../../../components/dashboard/propostas/historicoPropostaDialog";
import PropostasDialog from "../../../components/dashboard/propostas/propostasDialog";
import { statusBodyTemplate } from "../../../components/dashboard/propostas/propostaStatusBody";
import { useInfo } from "../../../context/infoContext";
import { Api } from "../../../services/api";
import { PaginatorPague } from "../../../styles/primeReactConfig";
import { formatCurrency } from "../../../utils/formatCurrency";


function Propostas() {
  const { providerInfo } = useInfo();
  const [propostas, setPropostas] = useState([]);
  const [showPropostaDetalhe, setShowPropostaDetalhe] = useState(false);
  const [showContraPropostaDetalhe, setShowContraPropostaDetalhe] = useState(false);
  const [showContraPropostaRetorno, setShowContraPropostaRetorno] = useState(false);
  const [showEndingDialog, setShowEndingDialog] = useState(false);
  const [showNegociacaoDetalhe, setShowNegociacaoDetalhe] = useState(false);
  const [showHistorico, setShowHistorico] = useState(false);
  const [propostaEscolhida, setPropostaEscolhida] = useState([]);
  const [propostaNegociada, setPropostaNegociada] = useState([])
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [rowsPerPageOptions] = useState([10, 20, 50]);
  const [first, setFirst] = useState(0);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [boletoData, setBoletoData] = useState([]);
  const [termoBase64, setTermoBase64] = useState([]);
  const [reload, setReload] = useState(false);
  // const {visao} = useInfo();
  //const today = new Date();

  useEffect(() => {
    const getPropostas = async () => {
      setLoading(true)
      try {
        const { data } = await Api.get(`propostas/listar`, {
            params: {
            limit,
            page,
          }
        })
        // console.log("LISTA", data.propostas)
        setPropostas(data.propostas)
        setTotal(data.count)
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getPropostas()
  }, [reload])

  const propostaStatusCluster = () => {
    const pccInfo = providerInfo?.parametros?.pcc_info;
    const aceita = !!pccInfo?.pcc_aceita_proposta;

    const iniISO = pccInfo?.pcc_proposta_enabled || null;
    const fimISO = pccInfo?.pcc_proposta_disabled || null;

    const fmt = (iso) => {
      if (!iso) return '-';
      try {
        const date = new Date(iso);
        date.setHours(date.getHours() - 3); // ajuste manual -3h
        return format(date, "dd/MM/yyyy HH:mm");
      } catch {
        return '-';
      }
    };

    return (
      <div className="flex items-center gap-3">
        {/* Status */}
        <Tag
          severity={aceita ? "success" : "danger"}
          value={<span style={{ fontSize: 14 }}>{aceita ? "Ativo" : "Inativo"}</span>}
          rounded
          className="px-3 py-1"
        />
        {/* Intervalo só quando Inativo */}
        {!aceita && (
          <div
            className="proposta-intervalo flex items-center gap-2 text-xs md:text-sm opacity-80 px-2 py-1 rounded-lg"
            data-pr-tooltip={`proposta de ${fmt(iniISO)} até ${fmt(fimISO)}`}
            data-pr-position="bottom"
            style={{ backgroundColor: 'rgba(255,255,255,0.06)' }}
          >
            <FaRegClock className="opacity-80" />
            <span>
              <b>Último período ativo:</b> {fmt(iniISO)} <span className="mx-1">→</span> {fmt(fimISO)}
            </span>
          </div>
        )}
      </div>
    );
  };




  const colunasPropostas = [
    {
      header: 'Ações',
      field: 'pnmt_valor_total',
      body: (rowData) => (
        <div className="flex justify-content-between gap-2">
          <Button icon={<FaPlus className="mr-2" />}
            label={dynamicLabel(rowData)}
            severity="info"
            disabled={rowData.pnmt_situacao === 'CANCELADA' || rowData.pnmt_situacao === 'NEGADA'}
            //style={{ width: "2.5rem", height: "2.5rem" }}
            onClick={() => openDialogStatus(rowData)}
          />
          <Button icon={<FaHistory className="mr-2" />}
            label={'Histórico'}
            severity="secondary"
            //style={{ width: "2.5rem", height: "2.5rem" }}
            onClick={() => abreHistorico(rowData)}
          />
        </div>
      ),
    },
    {
      header: 'Consumidor',
      field: 'cliente_nome',
      body: '',
    },
    {
      header: 'Data Criação',
      field: 'pnmt_created_at',
      body: (rowData) => format(new Date(rowData.pnmt_created_at), 'dd/MM/yyyy'),
    },
    {
      header: 'Status',
      field: 'pnmt_situacao',
      body: (rowData) => statusBodyTemplate(rowData),
    },
    {
      header: 'Valor',
      field: 'pnmt_valor_total',
      body: (rowData) => formatCurrency(rowData.pnmt_valor_total),
    },

  ]

  function openDialogStatus(rowData) {
    switch (rowData.pnmt_situacao) {
      case 'SOLICITADA':
        abrePropostaDetalhes(rowData)
        break;
      case 'EM ANALISE':
        abrePropostaDetalhes(rowData)
        break;
      case 'EM CONTRA PROPOSTA':
        abreContraPropostaDetalhes(rowData)
        break;
      case 'APROVADA':
        abreContraPropostaDetalhes(rowData)
        break;
      case 'NEGOCIADA':
        abreNegociacaoDetalhes(rowData)
        break;

      default:
        break;
    }
  }

  function dynamicLabel(rowData) {
    let label = ''
    switch (rowData.pnmt_situacao) {
      case 'SOLICITADA':
        label = 'Analisar'
        break;
      case 'EM ANALISE':
        label = 'Analisar'
        break;
      case 'EM CONTRA PROPOSTA':
        label = 'Detalhes'
        break;
      case 'APROVADA':
        label = 'Detalhes'
        break;
      case 'NEGOCIADA':
        label = 'Detalhes'
        break;

      default:
        break;
    }
    return label
  }

  function toastController(type, message) {
    toast(message, { type: type });
  }

  const colocaEmAnalise = async (proposta) => {
    const params = {
      valor_proposta: proposta.pnmt_valor_proposta,
      qtd_parcelas: proposta.pnmt_qtd_parcelas,
      entrada: proposta.pnmt_valor_entrada,
      descricao: proposta.pnmt_justificativa,
      acao: 'ANALISAR',
      proposta_id: proposta.pnmt_id,
    };

    try {
      setLoading(true);
      await Api.post('propostas/alterar', params);
      // Atualiza o array propostas em vez de propostaEscolhida
      setPropostas((prevPropostas) =>
        prevPropostas.map((p) =>
          p.pnmt_id === proposta.pnmt_id ? { ...p, pnmt_situacao: 'EM ANALISE' } : p
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status da proposta:', error);
      toast.error('Erro ao atualizar status da proposta');
    } finally {
      setLoading(false);
    }
  };

  const rejeitaProposta = async (justificativa) => {
    if (!propostaEscolhida?.pnmt_id) {
      toast.error('Erro: ID da proposta não encontrado. Tente novamente.');
      return;
    }

    const params = {
      valor_proposta: propostaEscolhida.pnmt_valor_proposta,
      qtd_parcelas: propostaEscolhida.pnmt_qtd_parcelas,
      entrada: propostaEscolhida.pnmt_valor_entrada,
      descricao: justificativa,
      acao: 'REJEITAR',
      proposta_id: propostaEscolhida.pnmt_id,
    };

    setLoading(true);
    try {
      await Api.post('propostas/alterar', params);
      toast.success('Proposta rejeitada com sucesso!');
      setShowPropostaDetalhe(false);
    } catch (error) {
      console.error('Erro ao rejeitar proposta:', error);
      toast.error('Erro ao rejeitar proposta, por favor tente novamente mais tarde');
    } finally {
      setLoading(false);
      setReload((prevState) => !prevState);
    }
  };

  const aceitaProposta = async (proposta) => {
    setLoading(true)
    try {
      const termo = await criaTermo(propostaEscolhida)

      const boleto = await criaNegociacao(proposta)
      const termo_criar = {
        base64: termo,
        boleto_id: boleto.id,
      };
      await Api.post('/genericTerm/create', termo_criar)

      const params = {
        valor_proposta: proposta.valorAPagar,
        qtd_parcelas: proposta.parcelas,
        entrada: proposta.entrada,
        descricao: proposta.justificativa,
        acao: proposta.acao,
        proposta_id: proposta.proposta_id,
        negociacao_id: boleto.negociacao_id,
      }

      await Api.post('propostas/alterar', params)
      setShowEndingDialog(true)
      setShowPropostaDetalhe(false)
      setShowContraPropostaRetorno(false)

      setReload(prevReload => !prevReload)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const criaTermo = async (proposta) => {
    const termo_body = {
      devedor_id: proposta.pnmt_cliente_id,
      credor_id: proposta.pnmt_usuario_id,
      qt_parcelas: Number(proposta.pnmt_valor_qtd_parcelas) + (Number(proposta.pnmt_valor_entrada) > 0 ? 1 : 0),
      valor_parcelas: (proposta.pnmt_valor_proposta - proposta.pnmt_valor_entrada) / proposta.pnmt_valor_qtd_parcelas,
      vencimento: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
      valor_total: proposta.pnmt_valor_proposta.toString(),
      multa: '2',
      juros: '1',
      taxa_envio: '0',
      valor_entrada: Number(proposta.pnmt_valor_entrada) > 0 ? proposta.pnmt_valor_entrada : undefined
    }
    try {
      const { data } = await Api.post('termo/criar', termo_body)
      setTermoBase64(data.base64_pdf_termo)
      console.table(termo_body)

      return data.base64_pdf_termo
      // const e = await criaNegociacao()

      // const termo_criar ={
      //     base64: data.base64_pdf_termo,
      //     boleto_id: e,
      // };
      // await Api.post('/genericTerm/create',termo_criar)  
    } catch (error) {
      console.log(error)
      return null
    }
  }

  const criaNegociacao = async (proposta) => {
    setLoading(true)
    try {
      const dataPagamento = criaPagamentoData(proposta);
      console.table(dataPagamento)
      const { data } = await
        toast.promise(Api.post(
          "/genericnegotiation/create",
          dataPagamento
        ),
          {
            pending: 'Gerando boleto',
            success: 'Sua negociação foi gerada com sucesso! Baixe o primeiro boleto agora',
            error: 'Erro ao gerar boleto, tente novamente mais tarde'
          }
        );
      setBoletoData(data[0])
      setLoading(false)
      setReload(prevState => !prevState)
      return (data[0])
    } catch (error) {
      setLoading(false);
      //toast.error('Erro ao gerar boleto, tente novamente mais tarde');
      console.log(error);
      return null
    }
  }

  function criaPagamentoData(proposta) {
    const PAYMENT_METHOD_QUANTITY = 1;
    const
      [{ pndt_cobranca_id }]
        = proposta.cobrancas;
    //console.log(proposta.valorAPagar)
    const entrada_sem_fee_pague = proposta.entrada > 0 ? ((proposta.entrada * 0.99) - proposta.fee_plataforma) : 0
    const fee_protesto_entrada = entrada_sem_fee_pague * proposta.fee_proporcional
    const valor_sem_fee_pague = proposta.valorAPagar - proposta.valorPague
    return {
      cobranca_id: pndt_cobranca_id,
      parcelas: proposta.parcelas + (Number(proposta.entrada) > 0 ? 1 : 0),
      tipo: 'boleto',
      cobranca_qtd_meio_pagamento: PAYMENT_METHOD_QUANTITY,
      valor: valor_sem_fee_pague,
      token_card: "",
      fee_direto: 1,
      tipo_fee: parseFloat(proposta.valorProtesto.toFixed(2)),
      fee_pague: parseFloat(proposta.valorPague.toFixed(2)),
      cartao_bandeira: null,
      entrada: proposta.entrada > 0 ? parseFloat(entrada_sem_fee_pague.toFixed(2)) : undefined,
      entrada_fee: proposta.entrada > 0 ? parseFloat(fee_protesto_entrada.toFixed(2)) : undefined,
      origem: 'PROPOSTA'
      // dia_vencimento_boleto: 19,
    };
  }

  const criaContraProposta = async (proposta) => {
    // console.log("PARAMS", proposta)
    // console.log("PARAMS", proposta.cobrancas[0].pnmt_id)

    setLoading(true)

    const params = {
      valor_proposta: proposta.valorAPagar,
      qtd_parcelas: proposta.parcelas,
      entrada: proposta.entrada,
      descricao: proposta.justificativa,
      acao: proposta.acao,
      proposta_id: proposta.cobrancas[0].pnmt_id
    }

    // console.log("PARAMS", params)

    try {
      await Api.post('propostas/alterar', params)
      toast.success('Contra-Proposta enviada ao consumidor com sucesso!!')
      setReload(prevReload => !prevReload)
      setShowContraPropostaDetalhe(false)
      setShowPropostaDetalhe(false)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  function abrePropostaDetalhes(rowData) {
    // console.log("situacao: ", rowData)
    setPropostaEscolhida(rowData); // Define o estado primeiro
    setShowPropostaDetalhe(true);
    // Chama colocaEmAnalise após o estado ser definido, apenas se necessário
    if (rowData.pnmt_situacao === "SOLICITADA") {
      colocaEmAnalise(rowData);
    }
  }

  function abreContraPropostaDetalhes(rowData) {
    setPropostaEscolhida(rowData);
    setShowContraPropostaRetorno(true);
    //colocaEmAnalise(rowData);
  }

  function abreNegociacaoDetalhes(rowData) {
    // console.log(rowData)
    setPropostaNegociada({ cobranca_id: rowData.negociacao_id });
    setShowNegociacaoDetalhe(true);
    //colocaEmAnalise(rowData);
  }

  function abreHistorico(rowData) {
    setPropostaEscolhida(rowData);
    setShowHistorico(true);
  }


  function onPage(event) {
    const startIndex = parseInt(event.first);
    setLimit(event.rows);
    setPage(event.page);
    setFirst(startIndex);
    setReload((prevReload) => !prevReload);
  };



  return (
    <AppCard>
      {showPropostaDetalhe && <PropostasDialog
        infoPropostas={propostaEscolhida}
        close={() => setShowPropostaDetalhe(false)}
        accept={(e) => { e.acao === 'CONTRA-PROPOSTA' ? criaContraProposta(e) : aceitaProposta(e) }}
        reject={(e) => rejeitaProposta(e)}
      />}
      {showContraPropostaDetalhe && <ContraPropostaDialog
        infoPropostas={propostaEscolhida}
        close={() => setShowContraPropostaDetalhe(false)}
      />}
      {showContraPropostaRetorno && <ContraPropostaRetornoDialog
        infoPropostas={propostaEscolhida}
        close={() => setShowContraPropostaRetorno(false)}
        accept={(e) => aceitaProposta(e)}
      />}
      {showEndingDialog && <EndingDialog
        negotiationInfo={{ termoBase64, boletoData }}
        close={() => setShowEndingDialog(false)}
      />}
      {showNegociacaoDetalhe && <NegotiationDetail
        rowInfo={propostaNegociada}
        close={() => setShowNegociacaoDetalhe(false)}
        toast={toastController}
      />}
      {showHistorico && <HistoricoPropostaDialog
        proposta_id={propostaEscolhida.pnmt_id}
        close={() => setShowHistorico(false)}
      />}
      <div className="card w-full grid">
        <Tooltip target=".proposta-intervalo" />
        <div className="w-full flex items-center justify-between flex-wrap gap-2">
          <h4 className="text-xl font-bold">Propostas Recebidas</h4>
          {propostaStatusCluster()}
        </div>
        <div className="w-full mt-2">
          <DataTable
            value={propostas}
            paginator
            first={first}
            rows={limit}
            rowsPerPageOptions={rowsPerPageOptions}
            totalRecords={total}
            onPage={onPage}
            pt={{
              paginator: PaginatorPague
            }}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
            lazy
            loading={loading}
          >
            {colunasPropostas.map((value) => {
              return (
                <Column
                  header={value.header}
                  field={value.field}
                  body={value.body}
                />
              )
            })
            }
          </DataTable>
        </div>
      </div>
    </AppCard>
  )
}
export default Propostas
